import React from 'react';
import { XCircleIcon, ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
export function ToolSavingsSection() {
  const replacedTools = [{
    name: 'Calendly',
    cost: '$12–16/mo'
  }, {
    name: 'Mailchimp',
    cost: '$20–50/mo'
  }, {
    name: 'Generic CRM',
    cost: '$25–80/mo'
  }, {
    name: 'Invoicing App',
    cost: '$15–40/mo'
  }, {
    name: 'Spreadsheets & DMs',
    cost: 'Hours of your time'
  }];
  return <section className="w-full bg-white-smoke py-16 md:py-24 px-4 relative" data-id="element-191">
      {/* Angled top */}
      <div className="absolute top-0 left-0 right-0 h-16 bg-jet-black" style={{
      clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0 100%)'
    }} data-id="element-192" />

      <div className="max-w-5xl mx-auto pt-8" data-id="element-193">
        <div className="text-center mb-14" data-id="element-194">
          <h2 className="text-3xl md:text-5xl font-extrabold text-jet-black mb-6" data-id="element-195">
            Cancel the Tool Chaos.{' '}
            <span className="text-viridia-green" data-id="element-196">
              Run Everything in One Place.
            </span>
          </h2>
          <p className="text-lg md:text-xl text-graphite-gray max-w-3xl mx-auto" data-id="element-197">
            Replace a patchwork of Calendly, Mailchimp, generic CRMs,
            spreadsheets, and random invoicing tools with one growth engine
            built for contractors.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-198">
          <div className="grid grid-cols-1 md:grid-cols-[1fr,auto,1fr]" data-id="element-199">
            {/* Tools being replaced */}
            <div className="p-8 md:p-10" data-id="element-200">
              <h3 className="text-xl font-bold text-red-600 mb-6 flex items-center gap-2" data-id="element-201">
                <XCircleIcon className="w-6 h-6" data-id="element-202" />
                Tools You're Paying For Now
              </h3>
              <ul className="space-y-4" data-id="element-203">
                {replacedTools.map((tool, index) => <li key={index} className="flex items-center justify-between gap-4 pb-3 border-b border-gray-100 last:border-0" data-id="element-204">
                    <span className="text-graphite-gray font-medium line-through decoration-red-300" data-id="element-205">
                      {tool.name}
                    </span>
                    <span className="text-sm text-red-500 font-semibold whitespace-nowrap" data-id="element-206">
                      {tool.cost}
                    </span>
                  </li>)}
              </ul>
              <div className="mt-6 pt-4 border-t-2 border-red-200" data-id="element-207">
                <div className="flex justify-between items-center" data-id="element-208">
                  <span className="font-bold text-graphite-gray" data-id="element-209">Total:</span>
                  <span className="text-red-600 font-bold text-lg" data-id="element-210">
                    $70–190+/mo + hours of manual work
                  </span>
                </div>
              </div>
            </div>

            {/* Arrow divider */}
            <div className="hidden md:flex items-center justify-center px-4" data-id="element-211">
              <div className="w-12 h-12 bg-viridia-green rounded-full flex items-center justify-center shadow-lg" data-id="element-212">
                <ArrowRightIcon className="w-6 h-6 text-white" strokeWidth={2.5} data-id="element-213" />
              </div>
            </div>
            <div className="md:hidden flex justify-center py-4" data-id="element-214">
              <div className="w-12 h-12 bg-viridia-green rounded-full flex items-center justify-center shadow-lg rotate-90" data-id="element-215">
                <ArrowRightIcon className="w-6 h-6 text-white" strokeWidth={2.5} data-id="element-216" />
              </div>
            </div>

            {/* Viridia replacement */}
            <div className="p-8 md:p-10 bg-viridia-green/5" data-id="element-217">
              <h3 className="text-xl font-bold text-viridia-green mb-6 flex items-center gap-2" data-id="element-218">
                <CheckCircleIcon className="w-6 h-6" data-id="element-219" />
                One System. Everything Included.
              </h3>
              <ul className="space-y-4" data-id="element-220">
                {['Instant lead response engine', 'Guided online booking', 'Full pipeline & CRM view', 'Custom-branded invoicing', 'Automated follow-up sequences'].map((item, index) => <li key={index} className="flex items-center gap-3 pb-3 border-b border-viridia-green/10 last:border-0" data-id="element-221">
                    <CheckCircleIcon className="w-5 h-5 text-viridia-green flex-shrink-0" strokeWidth={2} data-id="element-222" />
                    <span className="text-graphite-gray font-medium" data-id="element-223">
                      {item}
                    </span>
                  </li>)}
              </ul>
              <div className="mt-6 pt-4 border-t-2 border-viridia-green/20" data-id="element-224">
                <p className="text-center text-lg font-bold text-deep-teal" data-id="element-225">
                  Most clients save money every month by canceling overlapping
                  subscriptions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}